<template>
    <div class="main flex flex-col  w-full h-screen">
        <h2 class="backtext hidden md:block lg:block text-right select-none">Preguntas Frecue</h2>
        <img class="absolute  md:block lg:block muñeca my-auto p-6 opacity-10" src="@/assets/cios-dress.svg" />
        <div class="mt-20 flex flex-col md:mx-16">
            <h1 class="my-auto text-center text-2xl md:text-left md:text-5xl ">Preguntas Frecuentes</h1>
            <p class="my-auto text-center md:text-left">Acá encontraras las preguntas que nos hacen con mayor frecuencia!</p>
        </div>
        <div class="flex flex-row flex-wrap mx-auto overflow-auto z-20" style="max-height: 80vh;">
            <div class="p-1  w-full md:p-1 mx-auto flex flex-col md:w-1/2">
                <Acordions v-for="q in questions.slice(0, questions.length/2)" :key="q.question" :question="q.question" :answer="q.answer" />
            </div>
            <div class="p-1 w-full  md:p-1 mx-auto flex flex-col md:w-1/2">
                <Acordions v-for="q in questions.slice(questions.length/2, questions.length)" :key="q.question" :question="q.question" :answer="q.answer" />
            </div>
        </div>
    </div>
</template>
<script>
import Acordions from '@/components/acordion.vue'
export default {
    components: {
        Acordions
    },
    data() {
        return {
            questions: [
                { question: '¿Es necesario agendar una cita para probarse vestidos?', answer: 'No, nuestra tienda esta abierta de Martes a Sábados de 10:30 am a 5:30pm y trabajamos en horario corrido.' },
                { question: '¿Con que antelación puedo reservar/ alquilar el vestido?', answer: 'Con la antelación que desees, desde el mismo día del evento hasta un año de antelación.' },
                { question: '¿Cuánto tiempo dura el alquiler del vestido?', answer: 'Te lo puedes llevar hasta 3 días antes del evento y regresarlo hasta 3 días después. ' },

                { question: '¿Debo dejar algún deposito en garantía?', answer: 'Si, de acuerdo con cada prenda se solicita un depósito que se regresa al momento de devolver la misma en perfectas condiciones.' },
                { question: '¿Puedo realizarle ajustes al vestido?', answer: 'No, en la tienda tenemos personal calificado para ajustar el vestido a tu silueta.' },
                { question: '¿Debo lavar el vestido antes de regresarlo?', answer: 'No, nosotros lo lavamos en una tintorería especializada.' },
                { question: '¿Qué sucede si daño el vestido?', answer: 'Si el vestido sufre alguna rotura, quemada, mancha o cualquier daño, lo primero que debes haces es notificarlo y luego nosotros evaluaremos el costo de la reparación o reposición de la prenda y si este lo cubre el deposito en garantía se debitara de allí.' },
                { question: '¿Tienen Estacionamiento?', answer: 'Si el Centro Comercial cuenta con estacionamiento seguro y gratuito.' },
                { question: '¿Hacen envíos?', answer: 'Si alquilas un vestido es necesario que por lo menos te acerques una vez a la tienda para que lo escojas y se tomen las medidas para el ajuste, y ofrecemos servicio delivery en San Antonio de los Altos y Caracas.' },
                { question: '¿Puedo enviar a alguien a retirar o entregar el vestido?', answer: 'Si, siempre que traiga el recibo del alquiler.' },
                { question: '¿Qué sucede si no puedo regresar el vestido el día pautado?', answer: 'Inicialmente nos tienes que contactar para informarnos que tuviste algún inconveniente para devolver el vestido en la fecha establecida, y acorde a los días de retraso se cobra una multa.' },
            ],
        }
    },
}
</script>
<style scoped>
/*@media only screen and (min-width: 900px) {*/
.backtext {
    object-fit: cover;
    position: absolute;
    left: 37%;
    top: -0%;
    bottom: 63.7%;
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-weight: normal;
    font-size: 180px;
    letter-spacing: 0.02em;
    opacity: 0.07;
}

h1{
    font-family: 'Playfair Display', serif;
    font-style: italic;
    cursor: pointer;
}

p{
    font-family: 'Montserrat', serif;
}

.muñeca {

    position: absolute;
    width: 341px;
    height: 300px;
    left: 0%;
    top: 60%;
}


.main {
    position: relative;
    background: rgb(131, 133, 142);
    background: linear-gradient(330deg, rgba(131, 133, 142, 1) 0%, rgba(237, 237, 237, 0) 45%);
}
</style>